import { render, staticRenderFns } from "./FileUploadNotification.vue?vue&type=template&id=c81f4020"
import script from "./FileUploadNotification.vue?vue&type=script&lang=js"
export * from "./FileUploadNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports